export default __webpack_public_path__ + "523cbf9b38b3282f1bec5d010cf468bf.jpg";